import React, { useState, useEffect } from 'react';
import { projectsAPI, teamsAPI, teamtoolsAPI } from '../../services/api';

const ScriptGenerator = () => {
  const [projects, setProjects] = useState([]);
  const [teams, setTeams] = useState([]);
  const [projectTeams, setProjectTeams] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedWidget, setSelectedWidget] = useState('nextgame');  const [config, setConfig] = useState({
    project: '',
    team: '',
    theme: 'light',
    maxItems: 5,
    showLogos: true,
    language: 'en',
    compact: false,
    showPastGames: true,
    showPhotos: true,
    groupByPosition: true,
    showStats: false,
    tableView: 'centered', // 'full' or 'centered'
    scheduleToggles: 'all', // 'all', 'myteam', 'upcoming', 'none'
    scheduleFCW: 'normal', // 'normal' or 'fcw'
    rosterDesign: 'standard', // 'standard' or 'light'
    rosterTheme: 'light', // 'light', 'dark', 't12'
    // NextGame specific options
    nextgameTheme: 'standard', // 'standard', 'alt', 'werbung'
    nextgameProjects: [], // Array of project IDs for multi-project support
    nextgameMaxGames: 2
  });const [generatedCode, setGeneratedCode] = useState('');
  const [previewTheme, setPreviewTheme] = useState('light');
  const [previewData, setPreviewData] = useState(null);
  const [previewLoading, setPreviewLoading] = useState(false);

  const widgetTypes = [
    {
      id: 'nextgame',
      name: '🎯 Next Games',
      description: 'Shows upcoming and recent games for a team',
      needsTeam: true,
      needsProject: true
    },    {
      id: 'table',
      name: '📊 League Table',
      description: 'Displays the current league standings',
      needsTeam: false, // We'll handle this conditionally
      needsProject: true
    },    {
      id: 'schedule',
      name: '📅 Schedule',
      description: 'Shows all games for a project/round',
      needsTeam: true, // Optional team selection for filtering
      needsProject: true
    },    {
      id: 'roster',
      name: '👥 Team Roster',
      description: 'Displays team players and information',
      needsTeam: true,
      needsProject: true
    }
  ];

  useEffect(() => {
    fetchData();
  }, []);
  const fetchData = async () => {
    try {
      const [projectsRes, teamsRes] = await Promise.all([
        projectsAPI.getAll(),
        teamsAPI.getAll()
      ]);
      setProjects(projectsRes.data);
      setTeams(teamsRes.data);
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };  const fetchProjectTeams = async (projectId) => {
    if (!projectId) {
      setProjectTeams([]);
      return;
    }
    try {
      const response = await teamtoolsAPI.getByProject(projectId);
      const teams = response.data.map(item => ({
        _id: item.tid?._id || item.tid || item.id,
        name: item.tid?.name || item.name || 'Unknown Team'
      }));
      setProjectTeams(teams);
    } catch (error) {
      console.error('Error fetching project teams:', error);
      setProjectTeams([]);
    }
  };

  // Fetch project teams when project changes
  useEffect(() => {
    if (config.project) {
      fetchProjectTeams(config.project);
      // Reset team selection when project changes
      setConfig(prev => ({ ...prev, team: '' }));
    }
  }, [config.project]);  const generateScript = () => {
    // Use the API base URL without '/api' suffix for extern files  
    const apiBaseUrl = process.env.REACT_APP_API_URL || 'http://localhost:8080/api';
    const baseUrl = apiBaseUrl.replace('/api', ''); // Remove /api for extern files
    const widget = widgetTypes.find(w => w.id === selectedWidget);
    
    let scriptUrl = '';
    let configObject = {};
    let containerId = '';

    switch (selectedWidget) {      case 'nextgame':
        scriptUrl = `${baseUrl}/extern/mf-nextgame.js`;
        containerId = 'mf-nextgame-widget';
        if (config.project && config.team) {
          // Handle multiple projects if selected
          const projectIds = config.nextgameProjects.length > 0 
            ? config.nextgameProjects 
            : [config.project];
            configObject = {
            containerId: containerId,
            apiBaseUrl: apiBaseUrl, // Use full API URL with /api
            projectIds: projectIds,
            myTeamId: parseInt(config.team),
            theme: config.nextgameTheme || 'standard',
            maxGames: config.nextgameMaxGames || 2,
            showLogos: config.showLogos !== false
          };
        }
        break;
        
      case 'table':
        scriptUrl = `${baseUrl}/extern/mf-table.js`;
        containerId = 'mf-table-widget';        if (config.project) {
          configObject = {
            containerId: containerId,
            apiBaseUrl: apiBaseUrl, // Use full API URL with /api
            projectId: config.project,
            teamId: config.team || null,
            theme: config.theme || 'light',
            maxTeams: config.maxItems || 20,
            showLogos: config.showLogos !== false,
            compact: config.compact || false
          };
        }
        break;      case 'schedule':
        scriptUrl = `${baseUrl}/extern/mf-schedule.js`;
        containerId = 'mf-schedule-widget';        if (config.project) {          configObject = {
            containerId: containerId,
            apiBaseUrl: apiBaseUrl, // Use full API URL with /api
            projectId: config.project,
            myTeamId: config.team || null,
            theme: config.theme || 'light',
            showLogos: config.showLogos !== false,
            showToggles: config.scheduleToggles || 'all',
            useFCWLayout: config.scheduleFCW === 'fcw'
          };
        }
        break;      case 'roster':
        scriptUrl = `${baseUrl}/extern/mf-roster.js`;
        containerId = 'mf-roster-widget';        if (config.team && config.project) {
          configObject = {
            containerId: containerId,
            apiBaseUrl: apiBaseUrl, // Use full API URL with /api
            teamId: config.team,
            projectId: config.project,
            theme: config.rosterTheme || 'light',
            showPhotos: config.showPhotos !== false,
            groupByPosition: config.groupByPosition !== false,
            showStats: config.showStats || false,
            compact: config.compact || false,
            design: config.rosterDesign || 'standard'
          };
        }
        break;
    }    if (scriptUrl && Object.keys(configObject).length > 0) {
      const htmlStructure = getHtmlStructure(selectedWidget, containerId);      let fullCode;
      if (selectedWidget === 'schedule') {
        // Use new MFScheduleWidget class for schedule widget
        fullCode = `<!-- MF-League ${widget.name} Widget -->
${htmlStructure}
<script src="${scriptUrl}"></script>
<script>
document.addEventListener('DOMContentLoaded', function() {
    new MFScheduleWidget(${JSON.stringify(configObject, null, 4)});
});
</script>`;
      } else if (selectedWidget === 'roster') {
        // Use MFRosterWidget class for roster widget
        fullCode = `<!-- MF-League ${widget.name} Widget -->
${htmlStructure}
<script src="${scriptUrl}"></script>
<script>
document.addEventListener('DOMContentLoaded', function() {
    new MFRosterWidget(${JSON.stringify(configObject, null, 4)});
});
</script>`;
      } else if (selectedWidget === 'nextgame') {
        // Use MFNextGameWidget class for nextgame widget
        fullCode = `<!-- MF-League ${widget.name} Widget -->
${htmlStructure}
<script src="${scriptUrl}"></script>
<script>
document.addEventListener('DOMContentLoaded', function() {
    new MFNextGameWidget(${JSON.stringify(configObject, null, 4)});
});
</script>`;
      } else if (selectedWidget === 'table') {
        // Use MFTableWidget class for table widget
        fullCode = `<!-- MF-League ${widget.name} Widget -->
${htmlStructure}
<script src="${scriptUrl}"></script>
<script>
document.addEventListener('DOMContentLoaded', function() {
    new MFTableWidget(${JSON.stringify(configObject, null, 4)});
});
</script>`;
      } else {
        // Use legacy global config pattern for other widgets
        fullCode = `<!-- MF-League ${widget.name} Widget -->
${htmlStructure}
<script src="${scriptUrl}"></script>
<script>
window.MF${selectedWidget.charAt(0).toUpperCase() + selectedWidget.slice(1)}Config = ${JSON.stringify(configObject, null, 2)};
</script>`;
      }
      
      setGeneratedCode(fullCode);
    }
  };
  const getHtmlStructure = (widgetType, containerId) => {
    switch (widgetType) {
      case 'nextgame':
        return `<div id="${containerId}"></div>`;
      case 'table':
        return `<div id="${containerId}"></div>`;
      case 'schedule':
        return `<div id="${containerId}"></div>`;
      case 'roster':
        return `<div id="${containerId}"></div>`;
      default:
        return `<div id="${containerId || 'mf-widget'}"></div>`;
    }
  };
  const copyToClipboard = () => {
    navigator.clipboard.writeText(generatedCode);
    // You could add a toast notification here
    alert('Code copied to clipboard!');
  };
  const renderPreview = () => {
    if (!config.project && selectedWidgetInfo?.needsProject) {
      return (
        <div className="text-center text-gray-500">
          <div className="text-4xl mb-2">⚠️</div>
          <p>Please select a project to see the preview</p>
        </div>
      );
    }

    if (!config.team && selectedWidgetInfo?.needsTeam) {
      return (
        <div className="text-center text-gray-500">
          <div className="text-4xl mb-2">⚠️</div>
          <p>Please select a team to see the preview</p>
        </div>
      );
    }

    if (previewLoading) {
      return (
        <div className="text-center text-gray-500">
          <div className="text-4xl mb-2">⏳</div>
          <p>Loading preview data...</p>
          <div className="loading loading-spinner loading-md mt-2"></div>
        </div>
      );
    }

    if (!previewData) {
      return (
        <div className="text-center text-gray-500">
          <div className="text-4xl mb-2">❌</div>
          <p>No data available for preview</p>
        </div>
      );
    }

    const decodeHtml = (html) => {
      const txt = document.createElement('textarea');
      txt.innerHTML = html;
      return txt.value;
    };

    const extractLogo = (miscData) => {
      try {
        const misc = typeof miscData === 'string' ? JSON.parse(miscData) : miscData;
        return misc?.logog || misc?.logo || null;
      } catch {
        return null;
      }
    };

    // Render with real data based on widget type
    switch (selectedWidget) {
      case 'nextgame':
        if (!Array.isArray(previewData) || previewData.length === 0) {
          return (
            <div className="text-center text-gray-500">
              <div className="text-4xl mb-2">📅</div>
              <p>No games found for this team</p>
            </div>
          );
        }

        return (
          <div className={`mf-widget mf-widget-${previewTheme === 'dark' ? 'dark' : 'light'} max-w-md mx-auto`}>
            <div className="mf-nextgame-container p-4">
              {previewData.map((game, index) => {
                const gameDate = new Date(game.startdate);
                const isPast = new Date(game.startdate + ' ' + (game.starttime || '00:00')) < new Date();
                const homeTeam = decodeHtml(game.home?.name || 'Home Team');
                const awayTeam = decodeHtml(game.away?.name || 'Away Team');
                const homeLogo = config.showLogos && game.home?.misc ? extractLogo(game.home.misc) : null;
                const awayLogo = config.showLogos && game.away?.misc ? extractLogo(game.away.misc) : null;
                const score = game.played === 1 ? `${game.scoreh || 0} : ${game.scorea || 0}` : 'vs';

                return (
                  <div key={index} className={`mf-game ${isPast ? 'mf-game-past' : 'mf-game-upcoming'} mb-4 bg-white/10 backdrop-blur-sm rounded-lg p-4 border border-white/20`}>
                    <div className="mf-game-header flex justify-between text-sm opacity-75 mb-3">
                      <div className="mf-round font-semibold">{game.mfleague2_round?.name || 'Round'}</div>
                      <div className="mf-datetime">{gameDate.toLocaleDateString()} {game.starttime || ''}</div>
                    </div>
                    <div className="mf-game-content grid grid-cols-3 gap-4 items-center mb-3">
                      <div className="mf-team text-center">
                        {homeLogo && <img src={`${window.location.origin.replace('3000', '8080')}/${homeLogo}`} alt={homeTeam} className="w-12 h-12 rounded-full mx-auto mb-2 object-contain bg-white/10" />}
                        {!homeLogo && config.showLogos && <div className="w-12 h-12 rounded-full bg-blue-500 mx-auto mb-2 flex items-center justify-center text-white font-bold text-sm">{homeTeam.substring(0, 2)}</div>}
                        <div className="mf-team-name font-semibold text-sm">{homeTeam}</div>
                      </div>
                      <div className="mf-score text-center">
                        <div className="mf-score-display text-xl font-bold text-blue-500">{score}</div>
                      </div>
                      <div className="mf-team text-center">
                        {awayLogo && <img src={`${window.location.origin.replace('3000', '8080')}/${awayLogo}`} alt={awayTeam} className="w-12 h-12 rounded-full mx-auto mb-2 object-contain bg-white/10" />}
                        {!awayLogo && config.showLogos && <div className="w-12 h-12 rounded-full bg-red-500 mx-auto mb-2 flex items-center justify-center text-white font-bold text-sm">{awayTeam.substring(0, 2)}</div>}
                        <div className="mf-team-name font-semibold text-sm">{awayTeam}</div>
                      </div>
                    </div>
                    <div className="mf-game-footer text-center text-xs opacity-70">
                      {game.mfleague2_stadium?.name || 'TBD'}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        );

      case 'table':
        if (!Array.isArray(previewData) || previewData.length === 0) {
          return (
            <div className="text-center text-gray-500">
              <div className="text-4xl mb-2">📊</div>
              <p>No table data available</p>
            </div>
          );
        }

        return (
          <div className={`mf-widget mf-widget-${previewTheme === 'dark' ? 'dark' : 'light'} max-w-lg mx-auto`}>
            <div className="mf-table-container bg-white/10 backdrop-blur-sm rounded-lg overflow-hidden">
              <table className="w-full text-sm">
                <thead className="bg-blue-500/20">
                  <tr>
                    <th className="p-2 text-left">Pos</th>
                    <th className="p-2 text-left">Team</th>
                    <th className="p-2 text-center">P</th>
                    {!config.compact && <th className="p-2 text-center">GD</th>}
                    <th className="p-2 text-center font-bold">Pts</th>
                  </tr>
                </thead>
                <tbody>                  {previewData.map((team, idx) => {
                    const teamName = decodeHtml(team.name || 'Unknown Team');
                    const logo = config.showLogos ? extractLogo(team.misc) : null;
                    const isHighlighted = config.team && (team.id?.toString() === config.team || team.id === config.team);

                    return (
                      <tr key={idx} className={`border-b border-white/10 hover:bg-white/5 ${isHighlighted ? 'bg-green-500/20 font-semibold border-green-400' : ''}`}>
                        <td className="p-2 text-center">{team.position || idx + 1}</td>
                        <td className="p-2 flex items-center gap-2">
                          {logo && <img src={`${window.location.origin.replace('3000', '8080')}/${logo}`} alt={teamName} className="w-6 h-6 rounded-full object-contain bg-white/10" />}
                          {!logo && config.showLogos && <div className="w-6 h-6 rounded-full bg-gradient-to-r from-blue-500 to-purple-500 flex items-center justify-center text-white text-xs font-bold">{teamName.substring(0, 1)}</div>}
                          <span className="truncate">{teamName}</span>
                          {isHighlighted && <span className="text-green-400">👈</span>}
                        </td>
                        <td className="p-2 text-center">{team.gamesPlayed || team.games_played || 0}</td>
                        {!config.compact && <td className="p-2 text-center">{(team.goalDifference || team.goal_difference || 0) > 0 ? '+' : ''}{team.goalDifference || team.goal_difference || 0}</td>}
                        <td className="p-2 text-center font-bold">{team.points || team.pts || 0}</td>
                      </tr>
                    );
                  })}
                </tbody>              </table>
            </div>
          </div>
        );      case 'schedule':
        if (!Array.isArray(previewData) || previewData.length === 0) {
          return (
            <div className="text-center text-gray-500">
              <div className="text-4xl mb-2">📅</div>
              <p>No schedule data available</p>
            </div>
          );
        }        // Show first few games from preview data with team filtering logic
        let filteredGames = previewData;
        
        // For preview purposes, always show a good mix of games
        // If a team is selected, show their games first, then other games
        if (config.team) {
          const teamGames = previewData.filter(game => 
            (game.hid?._id === config.team || game.hid === config.team) || 
            (game.aid?._id === config.team || game.aid === config.team)
          );
          const otherGames = previewData.filter(game => 
            !((game.hid?._id === config.team || game.hid === config.team) || 
              (game.aid?._id === config.team || game.aid === config.team))
          );
          // Show team games first, then fill with other games for context
          filteredGames = [...teamGames, ...otherGames];
        }
        
        const gamesToShow = filteredGames.slice(0, 12);
        const selectedTeamName = config.team ? 
          (projectTeams.find(t => t._id === config.team)?.name || 'Selected Team') : 
          null;

        return (
          <div className="max-w-4xl mx-auto">
            {/* Mock Bootstrap-style controls */}
            <div className="bg-white/10 backdrop-blur border border-white/20 rounded-lg p-3 mb-3">
              <div className="flex flex-wrap gap-3 items-center text-xs">
                {/* Team selector */}
                <div className="flex items-center gap-2">
                  <label className="text-xs opacity-75">Team:</label>
                  <select className="bg-white/20 border border-white/30 rounded px-2 py-1 text-xs min-w-24">
                    <option value="">All Teams</option>
                    {selectedTeamName && <option value={config.team} selected>{selectedTeamName}</option>}
                    <option>Sample Team A</option>
                    <option>Sample Team B</option>
                  </select>
                </div>
                
                {/* View toggle buttons */}
                <div className="flex gap-1">
                  <button className={`px-3 py-1 rounded text-xs border ${!config.team ? 'bg-blue-500/20 border-blue-500/40 text-blue-400' : 'bg-white/10 border-white/20'}`}>
                    All Games
                  </button>
                  <button className={`px-3 py-1 rounded text-xs border ${config.team ? 'bg-blue-500/20 border-blue-500/40 text-blue-400' : 'bg-white/10 border-white/20 opacity-50'}`} 
                          disabled={!config.team}>
                    My Team
                  </button>
                </div>
                
                {/* Filters */}
                <label className="flex items-center gap-1 text-xs">
                  <input type="checkbox" className="w-3 h-3" />
                  Upcoming Only
                </label>
              </div>
            </div>

            {/* Games display */}
            {gamesToShow.length === 0 ? (
              <div className="text-center text-gray-500 py-8">
                <div className="text-2xl mb-2">📅</div>
                <p className="text-sm">No games found{config.team ? ' for selected team' : ''}</p>
              </div>            ) : (
              <div className="space-y-3">
                {gamesToShow.map((game, idx) => {
                  const gameDate = new Date(game.startdate);
                  const homeTeam = decodeHtml(game.home?.name || 'Home Team');
                  const awayTeam = decodeHtml(game.away?.name || 'Away Team');
                  const homeLogo = config.showLogos && game.home?.misc ? extractLogo(game.home.misc) : null;
                  const awayLogo = config.showLogos && game.away?.misc ? extractLogo(game.away.misc) : null;
                  const isPlayed = game.played === 1;
                  const isHighlighted = config.team && (
                    (game.hid?._id === config.team || game.hid === config.team) || 
                    (game.aid?._id === config.team || game.aid === config.team)
                  );

                  return (
                    <div key={idx} className={`bg-white/5 border border-white/10 rounded-lg p-3 ${isHighlighted ? 'border-green-400 bg-green-500/10' : ''}`}>
                      {/* Date and round header */}
                      <div className="text-xs text-gray-400 mb-3 text-center">
                        <div className="font-semibold text-blue-400 mb-1">
                          {game.roundName || `Round ${game.rid?.name || ''}`}
                        </div>
                        <div>
                          {gameDate.toLocaleDateString()}
                          {game.starttime && ` • ${game.starttime}`}
                        </div>
                      </div>

                      {/* Game matchup - horizontal layout like actual widget */}
                      <div className="flex items-center justify-between">
                        {/* Home team */}
                        <div className="flex items-center gap-2 flex-1">
                          {homeLogo && <img src={`${window.location.origin.replace('3000', '8080')}/${homeLogo}`} alt={homeTeam} className="w-8 h-8 rounded object-contain bg-white/10" />}
                          {!homeLogo && config.showLogos && <div className="w-8 h-8 rounded bg-blue-500 flex items-center justify-center text-white text-xs font-bold">{homeTeam.substring(0, 2)}</div>}
                          <span className="font-semibold text-sm">{homeTeam}</span>
                        </div>

                        {/* Score */}
                        <div className="flex items-center gap-2 px-4">
                          {isPlayed ? (
                            <div className="flex items-center gap-2">
                              <span className="bg-blue-500 text-white px-2 py-1 rounded text-sm font-bold min-w-[2rem] text-center">{game.scoreh || 0}</span>
                              <span className="text-gray-400">-</span>
                              <span className="bg-blue-500 text-white px-2 py-1 rounded text-sm font-bold min-w-[2rem] text-center">{game.scorea || 0}</span>
                            </div>
                          ) : (
                            <span className="text-gray-400 text-sm">vs</span>
                          )}
                        </div>

                        {/* Away team */}
                        <div className="flex items-center gap-2 flex-1 justify-end">
                          <span className="font-semibold text-sm text-right">{awayTeam}</span>
                          {awayLogo && <img src={`${window.location.origin.replace('3000', '8080')}/${awayLogo}`} alt={awayTeam} className="w-8 h-8 rounded object-contain bg-white/10" />}
                          {!awayLogo && config.showLogos && <div className="w-8 h-8 rounded bg-red-500 flex items-center justify-center text-white text-xs font-bold">{awayTeam.substring(0, 2)}</div>}
                        </div>
                      </div>

                      {/* Stadium info */}
                      {game.mfleague2_stadium?.name && (
                        <div className="text-xs text-gray-400 text-center mt-2 pt-2 border-t border-white/10">
                          📍 {game.mfleague2_stadium.name}
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        );

      case 'roster':
        if (!previewData || !previewData.players || previewData.players.length === 0) {
          return (
            <div className="text-center text-gray-500">
              <div className="text-4xl mb-2">👥</div>
              <p>No roster data available</p>
            </div>
          );
        }

        const positionMap = (previewData.positions || []).reduce((map, position) => {
          map[position.id] = position;
          return map;
        }, {});

        return (
          <div className={`mf-widget mf-widget-${previewTheme === 'dark' ? 'dark' : 'light'} max-w-lg mx-auto`}>
            <div className="mf-roster-container p-4">
              <div className="grid gap-3">
                {previewData.players.map((player, idx) => {
                  const playerData = player.mfleague2_player || player;
                  const name = decodeHtml(playerData.name || `${playerData.firstname || ''} ${playerData.lastname || ''}`.trim());
                  const number = playerData.number || playerData.jerseynumber || '';
                  const position = positionMap[playerData.posid]?.name || '';

                  return (
                    <div key={idx} className="mf-player-card bg-white/10 backdrop-blur-sm rounded-lg p-3 border border-white/20 relative">
                      <div className="flex items-center gap-3">
                        {config.showPhotos && (
                          <div className="w-12 h-12 rounded-full bg-gradient-to-r from-blue-500 to-purple-500 flex items-center justify-center text-white font-bold">
                            {name.split(' ').map(n => n[0]).join('').substring(0, 2)}
                          </div>
                        )}
                        <div className="flex-1">
                          <div className="font-semibold">{name}</div>
                          {!config.groupByPosition && position && <div className="text-sm opacity-70">{position}</div>}
                        </div>
                        {number && (
                          <div className="absolute top-2 right-2 w-8 h-8 bg-blue-500 rounded-full flex items-center justify-center text-white text-sm font-bold">
                            {number}
                          </div>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        );

      default:
        return (
          <div className="text-center text-gray-500">
            <div className="text-4xl mb-2">🔧</div>
            <p>Widget preview will appear here</p>
          </div>
        );
    }
  };
  useEffect(() => {
    if (config.project || config.team) {
      generateScript();
      fetchPreviewData();
    }
  }, [selectedWidget, config]);  const fetchPreviewData = async () => {
    if (!config.project && selectedWidgetInfo?.needsProject) return;
    if (!config.team && selectedWidgetInfo?.needsTeam && selectedWidget !== 'table' && selectedWidget !== 'schedule') return;

    setPreviewLoading(true);
    try {
      const baseUrl = process.env.REACT_APP_API_URL
        ? process.env.REACT_APP_API_URL.replace('/api', '')
        : window.location.origin;
      let data = null;

      switch (selectedWidget) {        case 'nextgame':
          if (config.project && config.team) {
            // Fetch all games for the project
            const allGamesRes = await fetch(`${baseUrl}/api/games`);
            
            if (allGamesRes.ok) {
              const gamesData = await allGamesRes.json();
              const allGames = gamesData.games || [];
              
              // Filter games for the specific team and project
              const teamGames = allGames.filter(game => 
                game.pid?._id === config.project && 
                (game.hid?._id === config.team || game.aid?._id === config.team)
              );
              
              // Sort by date
              teamGames.sort((a, b) => new Date(a.startdate) - new Date(b.startdate));
              
              const now = new Date();
              const today = now.toISOString().split('T')[0];
              
              const pastGames = teamGames.filter(game => {
                const gameDate = new Date(game.startdate).toISOString().split('T')[0];
                return gameDate < today && game.played;
              });
              const futureGames = teamGames.filter(game => {
                const gameDate = new Date(game.startdate).toISOString().split('T')[0];
                return gameDate >= today || !game.played;
              });
              
              const recentGame = pastGames.length > 0 ? [pastGames[pastGames.length - 1]] : [];
              const nextGames = futureGames.slice(0, config.maxItems - recentGame.length);
              
              data = [...recentGame, ...nextGames];
            }
          }
          break;case 'table':
          if (config.project) {
            const tableRes = await fetch(`${baseUrl}/api/table/project/${config.project}`);
            if (tableRes.ok) {
              const tableData = await tableRes.json();
              if (Array.isArray(tableData) && tableData.length > 0) {
                // Add position numbers
                const sortedData = tableData.map((team, index) => ({
                  ...team,
                  position: index + 1
                }));
                
                // If we have a team selected and using centered view
                if (config.team && config.tableView === 'centered') {
                  const teamPosition = sortedData.findIndex(team => 
                    team.id === config.team || team.id?.toString() === config.team
                  );
                  
                  if (teamPosition !== -1) {
                    // Calculate range around the team
                    const halfRange = Math.floor(config.maxItems / 2);
                    const start = Math.max(0, teamPosition - halfRange);
                    const end = Math.min(sortedData.length, start + config.maxItems);
                    
                    // Adjust start if we hit the end
                    const adjustedStart = Math.max(0, end - config.maxItems);
                    
                    data = sortedData.slice(adjustedStart, end);
                  } else {
                    // Team not found, show top teams
                    data = sortedData.slice(0, config.maxItems);
                  }
                } else {
                  // Full table view or no team selected
                  data = sortedData.slice(0, config.maxItems);
                }              } else {
                // Fallback to teams list if no table data
                const teamsRes = await fetch(`${baseUrl}/api/teamtools?pid=${config.project}`);
                if (teamsRes.ok) {
                  const teamsData = await teamsRes.json();
                  data = teamsData.slice(0, config.maxItems).map((team, index) => ({
                    position: index + 1,
                    id: team.tid?._id || team.tid || team.id,
                    name: team.tid?.name || team.name || 'Unknown Team',
                    points: 0,
                    gamesPlayed: 0,
                    wins: 0,
                    draws: 0,
                    losses: 0,
                    goalsFor: 0,
                    goalsAgainst: 0,
                    goalDifference: 0,
                    misc: team.tid?.misc || team.misc
                  }));
                }
              }
            }
          }
          break;        case 'schedule':
          if (config.project) {
            // Fetch games directly for this project
            const gamesRes = await fetch(`${baseUrl}/api/games?pid=${config.project}`);
            if (gamesRes.ok) {
              const gamesData = await gamesRes.json();
              let allGames = gamesData.games || [];
              
              // Add round information to games
              allGames = allGames.map(game => ({
                ...game,
                roundName: game.rid?.name || 'Round',
                roundStart: game.rid?.start,
                // Ensure proper team data structure
                home: game.hid || game.home,
                away: game.aid || game.away
              }));

              // Sort by date
              allGames.sort((a, b) => new Date(a.startdate) - new Date(b.startdate));
              
              // Limit to reasonable amount for preview
              data = allGames.slice(0, 20);
            }
          }
          break;

        case 'roster':
          if (config.team) {
            const [positionsRes, playersRes] = await Promise.all([
              fetch(`${baseUrl}/api/positions`),
              fetch(`${baseUrl}/api/playertools/team/${config.team}`)
            ]);
            
            if (positionsRes.ok && playersRes.ok) {
              const positions = await positionsRes.json();
              const players = await playersRes.json();
              
              data = {
                positions: positions,
                players: players.slice(0, config.maxItems)
              };
            }
          }
          break;
      }

      setPreviewData(data);
    } catch (error) {
      console.error('Error fetching preview data:', error);
      setPreviewData(null);
    } finally {
      setPreviewLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-96">
        <span className="loading loading-spinner loading-lg"></span>
      </div>
    );
  }

  const selectedWidgetInfo = widgetTypes.find(w => w.id === selectedWidget);

  return (
    <div className="">
      <div className="">
        {/* Header */}
        <div className="mb-12 fade-in">
          <div className="text-center">
            <h1 className="text-4xl font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent mb-4">
              🛠️ Widget Generator
            </h1>
            <p className="text-xl text-gray-600 dark:text-gray-300 max-w-3xl mx-auto">
              Generate embeddable JavaScript widgets for websites. Create custom sports widgets with your league data.
            </p>
          </div>
        </div>

        <div className="grid lg:grid-cols-2 gap-8">
          {/* Configuration Panel */}
          <div className="modern-card modern-card-hover p-6">
            <h2 className="text-2xl font-bold mb-6 flex items-center gap-3">
              <span className="w-8 h-8 bg-gradient-to-r from-blue-500 to-purple-500 rounded-full flex items-center justify-center text-white">⚙️</span>
              Configuration
            </h2>

            {/* Widget Type Selection */}
            <div className="mb-6">
              <label className="label">
                <span className="label-text font-semibold">Widget Type</span>
              </label>
              <div className="grid grid-cols-1 gap-3">
                {widgetTypes.map(widget => (
                  <div
                    key={widget.id}
                    className={`p-4 rounded-lg border-2 cursor-pointer transition-all duration-300 ${
                      selectedWidget === widget.id
                        ? 'border-blue-500 bg-blue-50 dark:bg-blue-900/20'
                        : 'border-gray-200 hover:border-gray-300'
                    }`}
                    onClick={() => setSelectedWidget(widget.id)}
                  >
                    <div className="flex items-start gap-3">
                      <input
                        type="radio"
                        className="radio radio-primary mt-1"
                        checked={selectedWidget === widget.id}
                        readOnly
                      />
                      <div>
                        <h3 className="font-semibold">{widget.name}</h3>
                        <p className="text-sm text-gray-600 dark:text-gray-400">{widget.description}</p>
                        <div className="flex gap-2 mt-2">
                          {widget.needsProject && <span className="badge badge-info badge-sm">Project Required</span>}
                          {widget.needsTeam && <span className="badge badge-warning badge-sm">Team Required</span>}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Project Selection */}
            {selectedWidgetInfo?.needsProject && (
              <div className="form-control mb-4">
                <label className="label">
                  <span className="label-text font-semibold">Project/League</span>
                </label>
                <select
                  className="select select-bordered"
                  value={config.project}
                  onChange={(e) => setConfig({...config, project: e.target.value})}
                >
                  <option value="">Select a project...</option>
                  {projects.map(project => (
                    <option key={project._id} value={project._id}>{project.name}</option>
                  ))}
                </select>
              </div>
            )}            {/* Team Selection */}
            {(selectedWidgetInfo?.needsTeam || selectedWidget === 'table') && (
              <div className="form-control mb-4">
                <label className="label">
                  <span className="label-text font-semibold">
                    Team {selectedWidget === 'table' ? '(Optional - for centered view)' : selectedWidget === 'schedule' ? '(Optional - for filtering)' : !selectedWidgetInfo.needsProject ? '(Optional)' : ''}
                  </span>
                </label>
                <select
                  className="select select-bordered"
                  value={config.team}
                  onChange={(e) => setConfig({...config, team: e.target.value})}
                  disabled={(selectedWidget === 'table' || selectedWidget === 'schedule') && !config.project}
                >
                  <option value="">Select a team...</option>
                  {(selectedWidget === 'table' || selectedWidget === 'schedule') && config.project ? 
                    projectTeams.map(team => (
                      <option key={team._id} value={team._id}>{team.name}</option>
                    )) :
                    teams.map(team => (
                      <option key={team._id} value={team._id}>{team.name}</option>
                    ))
                  }
                </select>
              </div>            )}            {/* Schedule-specific options */}
            {selectedWidget === 'schedule' && (
              <>
                <div className="form-control mb-4">
                  <label className="label">
                    <span className="label-text font-semibold">Toggle-Modus</span>
                  </label>
                  <select
                    className="select select-bordered"
                    value={config.scheduleToggles}
                    onChange={(e) => setConfig({...config, scheduleToggles: e.target.value})}
                  >
                    <option value="all">Alles (beide Toggles)</option>
                    <option value="myteam">Mein Team View + Kommende Spiele Toggle</option>
                    <option value="upcoming">Nur kommende Spiele Toggle</option>
                    <option value="none">Keine Toggles</option>
                  </select>
                  <div className="text-sm text-gray-500 mt-1">
                    {config.scheduleToggles === 'all' && 'Zeigt beide Filter-Toggles an (Mein Team + Kommende Spiele)'}
                    {config.scheduleToggles === 'myteam' && 'Zeigt Mein Team View als Standard + Kommende Spiele Toggle'}
                    {config.scheduleToggles === 'upcoming' && 'Zeigt nur "Kommende Spiele" Filter an'}
                    {config.scheduleToggles === 'none' && 'Zeigt keine Filter-Toggles an (reine Anzeigeansicht)'}
                  </div>
                  {config.scheduleToggles === 'myteam' && !config.team && (
                    <div className="text-sm text-warning mt-1">
                      ⚠️ Wählen Sie ein Team oben aus, um den "Mein Team" Modus zu verwenden
                    </div>
                  )}
                </div>
                
                <div className="form-control mb-4">
                  <label className="label">
                    <span className="label-text font-semibold">Layout-Stil</span>
                  </label>
                  <select
                    className="select select-bordered"
                    value={config.scheduleFCW}
                    onChange={(e) => setConfig({...config, scheduleFCW: e.target.value})}
                  >
                    <option value="normal">Standard Layout</option>
                    <option value="fcw">FCW Layout</option>
                  </select>
                  <div className="text-sm text-gray-500 mt-1">
                    {config.scheduleFCW === 'normal' && 'Verwendet das Standard-Karten-Layout'}
                    {config.scheduleFCW === 'fcw' && 'Verwendet das spezielle FCW-Layout mit Rundenübersicht'}
                  </div>
                </div>
              </>
            )}

            {/* Table-specific options */}
            {selectedWidget === 'table' && (
              <div className="form-control mb-4">
                <label className="label">
                  <span className="label-text font-semibold">Table View</span>
                </label>
                <select
                  className="select select-bordered"
                  value={config.tableView}
                  onChange={(e) => setConfig({...config, tableView: e.target.value})}
                >
                  <option value="full">Full Table (Top teams)</option>
                  <option value="centered">Centered around my team</option>
                </select>
                {config.tableView === 'centered' && !config.team && (
                  <div className="text-sm text-warning mt-1">
                    ⚠️ Select a team above to use centered view
                  </div>
                )}
              </div>
            )}{/* Additional Options */}
            <div className="space-y-4">
              <div className="form-control">
                <label className="label">
                  <span className="label-text font-semibold">Theme</span>
                </label>                <select
                  className="select select-bordered"
                  value={config.theme}
                  onChange={(e) => setConfig({...config, theme: e.target.value})}
                >
                  <option value="light">Light</option>
                  <option value="dark">Dark</option>
                  <option value="t12">T12 (Green)</option>
                </select>
              </div>              {/* Max Items - only for widgets that support it */}
              {selectedWidget !== 'schedule' && (
                <div className="form-control">
                  <label className="label">
                    <span className="label-text font-semibold">Max Items</span>
                  </label>
                  <input
                    type="number"
                    className="input input-bordered"
                    value={config.maxItems}
                    onChange={(e) => setConfig({...config, maxItems: parseInt(e.target.value)})}
                    min="1"
                    max="20"
                  />
                </div>
              )}

              <div className="form-control">
                <label className="cursor-pointer label">
                  <span className="label-text font-semibold">Show Team Logos</span>
                  <input
                    type="checkbox"
                    className="checkbox checkbox-primary"
                    checked={config.showLogos}
                    onChange={(e) => setConfig({...config, showLogos: e.target.checked})}
                  />
                </label>
              </div>

              {/* Compact Layout - only for widgets that support it */}
              {selectedWidget !== 'schedule' && (
                <div className="form-control">
                  <label className="cursor-pointer label">
                    <span className="label-text font-semibold">Compact Layout</span>
                    <input
                      type="checkbox"
                      className="checkbox checkbox-primary"
                      checked={config.compact}
                      onChange={(e) => setConfig({...config, compact: e.target.checked})}
                    />
                  </label>
                </div>
              )}{/* NextGame-specific options */}
              {selectedWidget === 'nextgame' && (
                <>
                  <div className="form-control">
                    <label className="label">
                      <span className="label-text font-semibold">NextGame Theme</span>
                    </label>
                    <select
                      className="select select-bordered w-full"
                      value={config.nextgameTheme}
                      onChange={(e) => setConfig({...config, nextgameTheme: e.target.value})}
                    >
                      <option value="standard">Standard (nextgame.js) - Tabs mit vergangenen & kommenden Spielen</option>
                      <option value="alt">Alt (nextgame_alt.js) - Letzte zwei gespielte Spiele</option>
                      <option value="werbung">Werbung (nextgame_werbung.js) - Kommende Spiele für Werbung</option>
                    </select>
                  </div>

                  <div className="form-control">
                    <label className="label">
                      <span className="label-text font-semibold">Additional Projects</span>
                      <span className="label-text-alt">Optional: Select additional projects to combine</span>
                    </label>
                    <div className="space-y-2">
                      {projects.map((project) => (
                        <label key={project._id} className="cursor-pointer label justify-start gap-3">
                          <input
                            type="checkbox"
                            className="checkbox checkbox-primary checkbox-sm"
                            checked={config.nextgameProjects.includes(project._id)}
                            onChange={(e) => {
                              const newProjects = e.target.checked
                                ? [...config.nextgameProjects, project._id]
                                : config.nextgameProjects.filter(id => id !== project._id);
                              setConfig({...config, nextgameProjects: newProjects});
                            }}
                          />
                          <span className="label-text text-sm">{project.name}</span>
                        </label>
                      ))}
                    </div>
                  </div>

                  <div className="form-control">
                    <label className="label">
                      <span className="label-text font-semibold">Max Games</span>
                    </label>
                    <input
                      type="number"
                      className="input input-bordered w-full"
                      value={config.nextgameMaxGames}
                      onChange={(e) => setConfig({...config, nextgameMaxGames: parseInt(e.target.value) || 2})}
                      min="1"
                      max="10"
                    />
                  </div>
                </>
              )}

              {/* Roster-specific options */}              {selectedWidget === 'roster' && (
                <>                  <div className="form-control">
                    <label className="label">
                      <span className="label-text font-semibold">Roster Design</span>
                    </label>
                    <select
                      className="select select-bordered w-full"
                      value={config.rosterDesign}
                      onChange={(e) => setConfig({...config, rosterDesign: e.target.value})}
                    >
                      <option value="standard">Standard (mit Modal & Details)</option>
                      <option value="light">Light (kompakt, ohne Modal)</option>
                    </select>
                  </div>

                  <div className="form-control">
                    <label className="label">
                      <span className="label-text font-semibold">Roster Theme</span>
                    </label>
                    <select
                      className="select select-bordered w-full"
                      value={config.rosterTheme}
                      onChange={(e) => setConfig({...config, rosterTheme: e.target.value})}
                    >
                      <option value="light">Light (helles Design)</option>
                      <option value="dark">Dark (dunkles Design)</option>
                      <option value="t12">T12 (Website Bootstrap Style)</option>
                    </select>
                  </div>

                  <div className="form-control">
                    <label className="cursor-pointer label">
                      <span className="label-text font-semibold">Show Player Photos</span>
                      <input
                        type="checkbox"
                        className="checkbox checkbox-primary"
                        checked={config.showPhotos}
                        onChange={(e) => setConfig({...config, showPhotos: e.target.checked})}
                      />
                    </label>
                  </div>

                  <div className="form-control">
                    <label className="cursor-pointer label">
                      <span className="label-text font-semibold">Group by Position</span>
                      <input
                        type="checkbox"
                        className="checkbox checkbox-primary"
                        checked={config.groupByPosition}
                        onChange={(e) => setConfig({...config, groupByPosition: e.target.checked})}
                      />
                    </label>
                  </div>

                  <div className="form-control">
                    <label className="cursor-pointer label">
                      <span className="label-text font-semibold">Show Player Stats</span>
                      <input
                        type="checkbox"
                        className="checkbox checkbox-primary"
                        checked={config.showStats}
                        onChange={(e) => setConfig({...config, showStats: e.target.checked})}
                      />
                    </label>
                  </div>
                </>
              )}
            </div>
          </div>

          {/* Generated Code Panel */}
          <div className="modern-card p-6">
            <h2 className="text-2xl font-bold mb-6 flex items-center gap-3">
              <span className="w-8 h-8 bg-gradient-to-r from-green-500 to-teal-500 rounded-full flex items-center justify-center text-white">📝</span>
              Generated Code
            </h2>

            {generatedCode ? (
              <div className="space-y-4">
                <div className="flex justify-between items-center">
                  <span className="text-sm text-gray-600">Copy this code to your website:</span>
                  <button
                    className="btn btn-sm btn-primary"
                    onClick={copyToClipboard}
                  >
                    📋 Copy Code
                  </button>
                </div>
                
                <div className="bg-gray-900 text-green-400 p-4 rounded-lg overflow-x-auto">
                  <pre className="text-sm whitespace-pre-wrap">{generatedCode}</pre>
                </div>                <div className="alert alert-info">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" className="stroke-current shrink-0 w-6 h-6">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                  </svg>
                  <div>
                    <h3 className="font-bold">Integration Instructions:</h3>
                    <ul className="text-sm mt-2 space-y-1">
                      <li>• Add this code to your HTML page where you want the widget to appear</li>
                      <li>• The widget includes modern styling and responsive design</li>
                      <li>• No external dependencies required - everything is self-contained</li>
                      <li>• The widget will automatically load and refresh data from your MF-League API</li>
                      <li>• Supports both light and dark themes with smooth animations</li>
                    </ul>
                  </div>
                </div>
              </div>
            ) : (
              <div className="text-center py-12 text-gray-500">
                <div className="text-6xl mb-4">🛠️</div>
                <h3 className="text-lg font-semibold mb-2">Configure Your Widget</h3>
                <p>Select a widget type and configure the options to generate your embeddable code.</p>              </div>
            )}
          </div>

          {/* Live Preview Panel */}
          {generatedCode && (
            <div className="modern-card p-6">
              <h2 className="text-2xl font-bold mb-6 flex items-center gap-3">
                <span className="w-8 h-8 bg-gradient-to-r from-purple-500 to-pink-500 rounded-full flex items-center justify-center text-white">👁️</span>
                Live Preview
              </h2>

              <div className="space-y-4">
                <div className="flex justify-between items-center">
                  <span className="text-sm text-gray-600 dark:text-gray-400">Preview of your widget:</span>
                  <div className="flex gap-2">
                    <button
                      className="btn btn-sm btn-outline"
                      onClick={() => setPreviewTheme(previewTheme === 'light' ? 'dark' : 'light')}
                    >
                      {previewTheme === 'light' ? '🌙' : '☀️'} Toggle Theme
                    </button>
                  </div>
                </div>
                
                <div className={`border-2 border-dashed border-gray-300 dark:border-gray-600 rounded-lg p-6 transition-colors ${previewTheme === 'dark' ? 'bg-gray-800' : 'bg-white'}`}>
                  <div 
                    id="widget-preview" 
                    className="min-h-[200px] flex items-center justify-center"
                    style={{
                      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
                      color: previewTheme === 'dark' ? '#f1f5f9' : '#1e293b'
                    }}
                  >
                    {renderPreview()}
                  </div>
                </div>

                <div className="alert alert-warning">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" className="stroke-current shrink-0 w-6 h-6">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.963-.833-2.732 0L4.082 15.5c-.77.833.192 2.5 1.732 2.5z"></path>
                  </svg>
                  <div>
                    <h3 className="font-bold">Preview Note:</h3>
                    <p className="text-sm">This is a simplified preview with mock data. The actual widget will load live data from your API and may look slightly different depending on your website's styling.</p>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ScriptGenerator;
